// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumb_container__2oqoG","mark":"Breadcrumb_mark__1bdWd","title":"Breadcrumb_title__19L25"};